module.exports = __webpack_public_path__ + "static/img/newsl.558a2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsl.png
// module id = TTWE
// module chunks = 45